import styled from "styled-components";
import React, { useEffect } from "react";

import ButtonWrapper from "./Buttons/Button";
import Primary from "./Buttons/Primary-Button";

if (typeof window !== "undefined") {
  require("materialize-css");
}

const HeaderWrapper = styled.div`
  background: black;
  padding: 8px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  z-index: 50;
  @media only screen and (max-width: 700px) {
    padding-bottom: 10px;
  }
`;

const LogoWrapper = styled.div`
  padding-right: 40px;
  padding-left: 10px;
`;

const LinkWrapper = styled.div`
  display: flex;
  @media only screen and (max-width: 700px) {
    padding-top: 10px;
    text-align: center;
    flex-wrap: wrap-reverse;
  }
`;

const Join = styled.div`
  @media only screen and (max-width: 700px) {
    position: absolute;
    right: 8px;
    top: 14px;
  }
`;

const Logo1 = styled.img`
  @media only screen and (max-width: 371px) {
    display: none;
  }
`;

const Logo2 = styled.img`
  @media only screen and (min-width: 370px) {
    display: none;
  }
`;

const Header = () => {
  useEffect(() => {
    var elems = document.querySelectorAll(".sidenav");
    var instances = M.Sidenav.init(elems, {});
    var elems = document.querySelectorAll(".dropdown-trigger");
    var instances = M.Dropdown.init(elems, { coverTrigger: false, constrainWidth: false });
  }, 0);
  return (
    <HeaderWrapper className="valign-wrapper">
      <LogoWrapper className="valign-wrapper">
        <a href="#" data-target="slide-out" className="sidenav-trigger hide-on-large-only">
          <i style={{ color: "red" }} className="material-icons">
            menu
          </i>
        </a>
        <a href="/">
          <div style={{ fontSize: "30px", paddingLeft: "20px", paddingTop: "5px" }}>
            <Logo2 style={{ height: "30px" }} src="/giglogo.png" />

            <Logo1 style={{ height: "30px" }} src="/GigIndiaLogo.svg" />
          </div>
        </a>
      </LogoWrapper>
      <LinkWrapper>
        <div className="right hide-on-med-and-down">
          <ButtonWrapper href="/freelancer" className="waves-effect waves-light btn-flat">
            Freelancer
          </ButtonWrapper>
          <ButtonWrapper href="/business" className="waves-effect waves-red btn-flat">
            Business
          </ButtonWrapper>
          <ButtonWrapper
            href="#"
            data-target="dropdown1"
            className="waves-effect waves-red btn-flat dropdown-trigger"
          >
            About Us
            <i style={{ float: "right" }} className="material-icons">
              keyboard_arrow_down
            </i>
          </ButtonWrapper>
        </div>
        <Join>
          <Primary href="/contact" className="btn waves-effect waves-light red">
            Contact Us
          </Primary>

          <ul id="slide-out" style={{ textAlign: "left" }} className="sidenav">
            <li>
              <a href="/freelancer" className="waves-effect waves-light btn-flat">
                Freelancer
              </a>
            </li>
            <li>
              <a href="/business" className="waves-effect waves-red btn-flat">
                Business
              </a>
            </li>
            <li>
              <a
                href="#"
                data-target="dropdown2"
                className="waves-effect waves-red btn-flat dropdown-trigger"
              >
                About Us
                <i style={{ float: "right" }} className="material-icons">
                  keyboard_arrow_down
                </i>
              </a>
            </li>
          </ul>

          <ul id="dropdown1" className="dropdown-content z-depth-4">
            <li>
              <a style={{ color: "black" }} href="/company">
                Company
              </a>
            </li>
            <li>
              <a style={{ color: "black" }} href="/customers">
                Customers
              </a>
            </li>
            <li>
              <a style={{ color: "black" }} href="/company#press">
                Press
              </a>
            </li>
            <li>
              <a style={{ color: "black" }} href="/contact">
                Contact
              </a>
            </li>
          </ul>

          <ul id="dropdown2" className="dropdown-content z-depth-4">
            <li>
              <a style={{ color: "black" }} href="/company">
                Company
              </a>
            </li>
            <li>
              <a style={{ color: "black" }} href="/customers">
                Customers
              </a>
            </li>
            <li>
              <a style={{ color: "black" }} href="/company#press">
                Press
              </a>
            </li>
            <li>
              <a style={{ color: "black" }} href="/contact">
                Contact
              </a>
            </li>
          </ul>
        </Join>
      </LinkWrapper>
    </HeaderWrapper>
  );
};

export default Header;
